import React from 'react';
import { PopoverOrigin } from '@material-ui/core';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import {withStyles} from '@material-ui/core/styles';

const menuAnchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right'
};

const menuTransformOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right'
};

const StyledMenu = withStyles({
  paper: {
    marginTop: '20px',
    // boxShadow: '0px 6px 13px 1px rgb(0 0 0 / 7%)',
    // borderRadius: '3px',
    width: '232px'
  }
})( (props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={menuAnchorOrigin}
    transformOrigin={menuTransformOrigin}
    {...props}
  />
));

export default StyledMenu;
